export const PERFORMANCE_HOME_CREATION = 'HOME:CREATION'
export const PERFORMANCE_HOME_LOADING = 'HOME:LOADING'
